import {
  AvailablePitchTypesAndGroupsDto,
  DateRangeDto,
  SelectedItemDto,
  UmpireReportContentConfigDto,
  UmpireReportForSessionChartConfigDto,
  UmpireReportForSessionChartDataDto,
  UmpireCall,
} from 'types/CodegenReportTypes';

import { configurablePitchTypeGroups, configurablePitchTypes, umpireCallCorrectnessOptions } from 'utilities/constants';
import { generateStore } from 'utilities/reportStoreFactory';

type ReportSpecificTypes = {
  // search criteria come from select fields and their type must match selected entries from ...FilterDto type
  // ...FilterDto minus { reportId, configData, reportContentConfig }
  searchCriteria: {
    dateRanges: DateRangeDto[] | undefined;
    seasonNames: string[] | undefined;
    leagues: SelectedItemDto[] | undefined;
    umpires: SelectedItemDto[] | undefined;
    session: SelectedItemDto | undefined;
  };
  // search chips type must match selected entries from ...ResultDto type
  // ...ResultDto minus { reportId, reportType, reportSubType, reportContentConfig, chartData, configData } AND minus specialConfigOptions
  searchChips: {
    seasonNames: string[] | undefined;
    dateRanges: DateRangeDto[] | undefined;
    leagueNames: string[] | undefined;
    umpireNames: string[] | undefined;
    sessionName: string | undefined;
  };

  // filters / config area
  specialConfigOptions: { pitchTypeInfo: AvailablePitchTypesAndGroupsDto } | undefined; // config related values from ...ResultDto
  selectedConfgValues: UmpireReportContentConfigDto; // reportContentConfig

  // charts area
  layout: UmpireReportForSessionChartConfigDto | undefined; // configData
  chartData: UmpireReportForSessionChartDataDto[] | undefined; // chartData
};

const defaultValues: ReportSpecificTypes = {
  // search criteria area
  searchCriteria: {
    dateRanges: undefined,
    seasonNames: undefined,
    leagues: undefined,
    umpires: undefined,
    session: undefined,
  },
  searchChips: {
    seasonNames: undefined,
    dateRanges: undefined,
    leagueNames: undefined,
    umpireNames: undefined,
    sessionName: undefined,
  },

  // filters / config area
  specialConfigOptions: undefined,
  selectedConfgValues: {
    pitchTagging: 'Auto',
    pitchTypes: configurablePitchTypes,
    pitchTypeGroups: configurablePitchTypeGroups,
    pitchGrouping: 'Types',
    pitcherHandedness: 'Both',
    batterHandedness: 'Both',
    strikeZoneDisplay: 'WithBuffers',
    includedCalls: 'All',
    includedCallCorrectness: umpireCallCorrectnessOptions,
  },

  // charts area
  layout: undefined,
  chartData: undefined,
};

const useReportStore = generateStore(defaultValues);

export default useReportStore;
